import { AbstractControl, ValidatorFn } from '@angular/forms';

/**
 * Validator that requires two controls to have matching values.
 * Note that this validator only checks the value of the matching control
 * if the control itself has no other errors. If the matching control has
 * some other error, this validator will not override it.
 * @param controlName The name of the control to check
 * @param matchingControlName The name of the matching control
 * @returns A validator function that returns null if the values match and
 * an object with a `mustMatch` property if they do not.
 */
export function mustMatchValidator(controlName: string, matchingControlName: string): ValidatorFn {
  return (group: AbstractControl) => {
    const control = group.get(controlName);
    const matchingControl = group.get(matchingControlName);
    if (matchingControl?.errors && !matchingControl.errors['mustMatch']) {
      return null; // Skip validation if another error is present
    }

    if (control?.value !== matchingControl?.value) {
      matchingControl?.setErrors({ mustMatch: true });
    } else {
      matchingControl?.setErrors(null);
    }

    return null;
  };
}
